module.exports = __webpack_public_path__ + "static/media/ic-edit-hover.bfceb265.svg";